// extracted by mini-css-extract-plugin
export default {"profilePage":"profile_profilePage__xv2Kc","header":"profile_header__0NY7e","singleLine":"profile_singleLine__6guSY","infos":"profile_infos__f4Vbj"};